import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TicketIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TicketIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M9.02541 13.3445V12.2029C9.02541 11.8928 9.24349 11.6304 9.54337 11.552C10.2965 11.3578 10.8826 10.7512 11.053 9.98787H3.02777C2.65973 9.98787 2.35986 10.2878 2.35986 10.6558V12.0155C2.35986 12.3256 2.57794 12.588 2.87783 12.6664C3.77406 12.8947 4.43517 13.7091 4.43517 14.6769C4.43517 15.6447 3.77406 16.4592 2.87783 16.6875C2.57794 16.7659 2.35986 17.0283 2.35986 17.3384V18.48C2.35986 18.848 2.65973 19.1479 3.02777 19.1479H15.0264C15.3945 19.1479 15.6943 18.848 15.6943 18.48V17.335C15.6943 17.0249 15.4797 16.7659 15.1832 16.6875C14.2938 16.4524 13.6395 15.6413 13.6395 14.6803C13.6395 14.4486 13.677 14.2237 13.7485 14.0124H9.69331C9.32527 14.0124 9.02541 13.7125 9.02541 13.3445Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.8487 7.53419C22.1486 7.45581 22.3599 7.19341 22.3599 6.88672V5.52021C22.3599 5.15218 22.06 4.85229 21.692 4.85229H9.69333C9.3253 4.85229 9.02543 5.15218 9.02543 5.52021V6.8799C9.02543 7.19001 9.24351 7.4524 9.54339 7.53078C10.4396 7.7591 11.1007 8.57355 11.1007 9.54135C11.1007 9.6947 11.0837 9.84464 11.0496 9.98776H15.023C15.3911 9.98776 15.691 10.2876 15.691 10.6557V12.0222C15.691 12.3323 15.4763 12.5913 15.1798 12.6697C14.5085 12.8469 13.9701 13.3546 13.7451 14.0089H21.6886C22.0566 14.0089 22.3565 13.709 22.3565 13.341V12.196C22.3565 11.8859 22.1418 11.6269 21.8454 11.5485C20.9559 11.3134 20.3016 10.5023 20.3016 9.54135C20.3016 8.58037 20.9559 7.76932 21.8454 7.53419"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TicketIcon;
